import React from 'react';
import {Link} from 'react-router-dom';
import I18n from 'app/i18n';
import {betMoney, scrollToTop} from 'app/utils';
import {artifactDescription, artifactName, artifactShopLink} from 'app/components/my_profile/artifacts/utils';
import PrizeCard from 'app/components/reusable/PrizeCard';
import DefaultSign from 'app/components/shop/DefaultSign';
import {ArtifactLike} from 'app/utils/artifactToLoot';
import MultiLangsInterface from 'app/interfaces/MultiLangsInterface';

export interface MarketplaceRecipeProps extends ArtifactLike {
    artifact_price: number | string
    description: string
    description_langs: MultiLangsInterface
    id: number
    image: string
    langs: MultiLangsInterface
    max_order_price: number | string | null
    name: string
    quantity: number | null
    slug: string
    start_price: number | string | null
}

const Recipe = (props: MarketplaceRecipeProps): React.ReactElement => {
    const {artifact_price, max_order_price, quantity, start_price} = props;
    const hasQuantity = Boolean(quantity);
    const hasBuyRequest = Number(max_order_price) > 0;
    const hasArtifactPrice = Number(artifact_price) > 0;

    return <div className="market__item">
        <div className="market__item__name-quantity">
            <div className="market__item--img-wrap">
                <div className="market__item--img market-item-card">
                    <Link to={artifactShopLink(props)} onClick={scrollToTop}>
                        <PrizeCard artifact={props} hideMeta hideName/>
                    </Link>
                </div>
            </div>
            <div className="market__item--desc-quantity">
                <div className="market__item--desc">
                    <div className="market__item--desc-title">
                        <Link to={artifactShopLink(props)} onClick={scrollToTop}>{artifactName(props)}</Link>
                    </div>
                    <div className="market__item--desc-text">
                        {artifactDescription(props)}
                    </div>
                </div>
                <div className="market__item__quantity">
                    <span className="mobile-label">{I18n.t('quantity')}:</span>
                    {quantity || 0}
                </div>
            </div>
        </div>
        <div className="market__item__price-col">
            <DefaultSign condition={hasQuantity || hasBuyRequest} className="market__item__price">
                <div className="market__item__sell-order">
                    <span className="market__item__label">{I18n.t('sell_order_from')}:</span>
                    <DefaultSign condition={hasQuantity} className="market__item__price-value">
                        {betMoney({amount: start_price})}
                    </DefaultSign>
                </div>
                <div className="market__item__sell-order">
                    <span className="market__item__label">{I18n.t('buy_request_from')}:</span>
                    <DefaultSign condition={hasBuyRequest} className="market__item__price-value">
                        {betMoney({amount: max_order_price})}
                    </DefaultSign>
                </div>
                <span className="market__item__label">{I18n.t('average_price')}:</span>
                <DefaultSign condition={hasArtifactPrice} className="market__item__price-value">
                    {betMoney({amount: artifact_price})}
                </DefaultSign>
            </DefaultSign>
        </div>
    </div>;
};

export default Recipe;
